import { render } from "./universalQuotes.vue?vue&type=template&id=046ece8a"
import script from "./universalQuotes.vue?vue&type=script&lang=js"
export * from "./universalQuotes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__